import { render, staticRenderFns } from "./productList.view.vue?vue&type=template&id=7ac88e06&scoped=true&lang=pug"
import script from "./productList.view.vue?vue&type=script&lang=ts"
export * from "./productList.view.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ac88e06",
  null
  
)

export default component.exports